import type { StylableElementProps } from '@subaio/components'

import { BrandOriginal } from './Original'
import { BrandSquare } from './Square'

type Props = StylableElementProps & {
	brandId?: string
	size?: number
	type?: 'square' | 'original'
}

export const Brand = ({ brandId, size, type = 'square', className, style }: Props) => {
	switch (type) {
		case 'square':
			return <BrandSquare size={size} brandId={brandId} className={className} style={style} />
		case 'original':
			return <BrandOriginal height={size} brandId={brandId} className={className} style={style} />
	}
}
